

























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardAsesmenGeriatri from "./geriatri/CardAsesmenGeriatri.vue";
import AsesmenGeriatriStore from "@/store/modules/AsesmenGeriatriStore";

@Component({
  components: {
    CardAsesmenGeriatri
  }
})
export default class AsesmenGeriatriPage extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number;

  @Prop({ type: Boolean, default: false }) isActive!: boolean;
  @Prop({ type: Boolean, default: true }) barthelAwalOtomatis!: boolean;

  get loading() {
    return AsesmenGeriatriStore.loading;
  }

  get stateData() {
    return AsesmenGeriatriStore.data;
  }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val && !AsesmenGeriatriStore.isLoadedFor(this.register)) {
      this.getByRegister();
    }
  }

  mounted() {
    if (this.isActive && !AsesmenGeriatriStore.isLoadedFor(this.register)) {
      this.getByRegister();
    }
  }

  async getByRegister() {
    await AsesmenGeriatriStore.getByRegister(this.register);
  }
}
